/**
 * @file routes.ts
 *
 * @fileoverview Include routes for the application.
 */
const jobiqoRoutesConfig = require('./../src/jobiqo/config/routes');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

module.exports = mergeDeepRight(jobiqoRoutesConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  removeQuerystringParams: [
    {
      source: '/jobs',
      removeQs: [
        'keywords',
      ],
    },
  ],
  redirects: [
    ...jobiqoRoutesConfig.redirects,
    // Blog detail and Blog search redirects.
    {
      source: '/career-resources',
      destination: '/',
      permanent: true,
    },
    {
      source: '/career-resources/:path*',
      destination: '/',
      permanent: true,
    },
    // Organization profile search page redirect.
    {
      source: '/employer-directory',
      destination: '/organizations',
      permanent: true,
    },
    {
      source: '/employer-directory/:path*',
      destination: '/organizations',
      permanent: true,
    },
    // Job search page redirect.
    {
      source: '/browse-jobs',
      destination: '/jobs',
      permanent: true,
    },
    // Job search by Location.
    {
      source: '/browse-jobs/in/:path',
      destination: '/jobs/:path',
      permanent: true,
    },
    // Redirect old jobs by companies letters list to the job search.
    {
      source: '/browse-jobs/companies/:path',
      destination: '/jobs',
      permanent: true,
    },
    // Redirect old jobs by title letters list to the job search.
    {
      source: '/browse-jobs/titles/:path',
      destination: '/jobs',
      permanent: true,
    },
    // User related redirects.
    {
      source: '/forgot-password',
      destination: '/user/reset-password',
      permanent: true,
    },
    {
      source: '/register-employer',
      destination: '/user/register/recruiter',
      permanent: true,
    },
    {
      source: '/register-seeker',
      destination: '/user/register/applicant',
      permanent: true,
    },
    {
      source: '/sign-in',
      destination: '/user/login',
      permanent: true,
    },
  ],
});
